import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class MenuRepositoryService {
    constructor(http) {
        this.http = http;
    }
    items() {
        return this.http.get(`${environment.apiUrl}v1/menu`);
    }
}
MenuRepositoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenuRepositoryService_Factory() { return new MenuRepositoryService(i0.ɵɵinject(i1.HttpClient)); }, token: MenuRepositoryService, providedIn: "root" });
